import React, { useCallback } from 'react';
import { FIELD_NAMES } from '../../../../../../address/address-fields/constants';
import { PHONE } from '../../../../../../address/constants';
import { PHONE_NEEDED_FOR_SOME_CARRIERS } from '../../../../../../address/sublabel-constants';
import { Text } from '../../../../../../ui-components/components/text';
import { WalletAddress } from '../../../../../components/wallet-address';
import { messages } from '../../../../../messages';
import { FORM_REQUIREMENTS } from '../../../../../utilities/constants';
import { PERSONAL } from '../../../../constants';
import { useWalletRegistrationErrorContext } from '../../../contexts/wallet-registration-error-context';
import { useWalletRegistrationFormContext } from '../../../contexts/wallet-registration-form-context';
import style from '../../../style.module.less';

import { PickupAddressSchema } from '../pickup-address-schema';

/**
 * @param {object} props
 * @param {'personal' | 'business'} props.accountType - The account type (PERSONAL or BUSINESS)
 * @param {string} [props.className] - Optional CSS class name for the wrapper
 * @param {(requirement: string, isValid: boolean) => void} props.markFormComplete - Function to mark form completion status
 * @param {string} [props.headerTextType] - The text type for the header
 * @returns {JSX.Element}
 */
export const WalletPickupAddress = ({ accountType, className, markFormComplete, headerTextType }) => {
  const { walletForm, updateWalletForm, submittingRegistration } = useWalletRegistrationFormContext();
  const { validationErrors } = useWalletRegistrationErrorContext();

  const { COMPANY } = FIELD_NAMES;

  const onChange = useCallback(
    ({ propertyName, value }) => {
      updateWalletForm([FORM_REQUIREMENTS.PICKUP_ADDRESS, propertyName], value);
    },
    [updateWalletForm],
  );

  const onValidationChange = useCallback(
    (isValid) => {
      markFormComplete(FORM_REQUIREMENTS.PICKUP_ADDRESS, isValid);
    },
    [markFormComplete],
  );

  const hiddenFields = accountType === PERSONAL ? [COMPANY] : [];

  const subLabels = {
    [PHONE]: PHONE_NEEDED_FOR_SOME_CARRIERS,
  };

  return (
    <div className={className}>
      <Text className={style['pickup-header']} textType={headerTextType} value={messages.pickupAddressHeader} />
      <WalletAddress
        accountType={accountType}
        address={walletForm?.[FORM_REQUIREMENTS.PICKUP_ADDRESS]}
        disabled={submittingRegistration}
        errors={validationErrors?.[FORM_REQUIREMENTS.PICKUP_ADDRESS]}
        hiddenFields={hiddenFields}
        onChange={onChange}
        onValidationChange={onValidationChange}
        subLabels={subLabels}
        validationSchema={PickupAddressSchema}
      />
    </div>
  );
};
